
import TableList from "@components/templates/tablelist";
import { HttpGetResourceList, HttpGetResourceCancel } from "@/service/products/promotion";
import { mapState, mapGetters } from "vuex";
import compImport from '../../compimport'
import comIndex from './update'
export default {
    mixins: [TableList],
    components: {
        comIndex,
        compImport
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                    EQ_type:1,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            datename:'',
            datetime:'',
            Plugins: {show: true},
            initData:'',
        };
    },

    methods: {
        ajaxRequest: HttpGetResourceList,
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'promotionResourceUpdate',
                        params: { type: "add"},
                        query: { sourceType: this.formData.search.EQ_type}
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'promotionResourceUpdate',
                        params: { type: "edit"},
                        query: { id: params , sourceType: this.formData.search.EQ_type },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "deleted":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params, status:3},
                        title: "批量删除操作",
                        ajaxRequest:HttpGetResourceCancel
                    }
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: '导入资源',
                        width: 460,
                        showFooter: false,
                        erpskutitle: "直接更新：名称、网址以外的其他数据直接更新",
                        component: "compImport",
                        comptitle: '已存在资源信息',
                        importType:this.formData.search.EQ_type,
                        actionurl: "/api/v2/promotionResource/import",
                        downrul: '/api/v2/promotionResource/excel',
                    }
                    break;
                case 'export':
                    if(this.total>2000){
                        this.$VMessage.error('导出数据不能大于2000');
                    }else{
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/promotionResource/exportByFilter',this.formData,{
                            executor:'request',
                            download:true,
                        }).catch(err=>{
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                        });
                    }
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id } = row
            return [{
                label:'查看',
                show:true,
                params:id,
                operate:'query'
            },{
                label:'编辑',
                show: true,
                params:id,
                operate:'edit'
            }, ]
        },
    },
    computed: {
        TabsData(){
            return [
                {
                    name: "Deal站资源",
                    key:'EQ_type',
                    val: 1
                }, {
                    name: "FB群组资源",
                    key:'EQ_type',
                    val: 2
                }, {
                    name: "红人资源",
                    key:'EQ_type',
                    val: 3
                }, {
                    name: "联盟商资源",
                    key: "EQ_type",
                    val: 4
                }
            ]
        },
        ToolsData(){
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "导入",
                    operate: "import",
                    theme: "warning",
                },
                {
                    name: "查询条件导出",
                    operate: "export",
                    theme: "primary",
                },
                {
                    name: "批量删除",
                    batch:true,
                    operate: "deleted",
                    theme: "error",
                },

            ]
        },
        SearchsData() {
            return  [
                {
                    label: "国家",
                    tag: 'vInput',
                    key: 'EQ_countryCode',
                    show:true,
                },
                {
                    label: "名称",
                    tag: 'vInput',
                    key: 'CN_resourcesName',
                    show:true,
                },
                {
                    label: "alexa全球排名",
                    tag: 'vInput',
                    key: 'EQ_alexaRank',
                    show:true,
                },

                // 隐藏起来的搜索
                {
                    label: "属性",
                    tag: 'vInput',
                    key: 'EQ_attribute',
                    hidden:!(this.formData.search['all']==null),
                },
                {
                    label: "创建人",
                    tag: 'vInput',
                    key: 'CN_createdName',
                    hidden:!(this.formData.search['all']==null),
                },
                {
                    label: '创建时间',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    style: "width:180px",
                    hidden:!(this.formData.search['all']==null),
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },
                {
                    label: '回复时间',
                    tag: 'vDatepicker',
                    key: 'BT_replyTime',
                    style: "width:180px",
                    hidden:!(this.formData.search['all']==null),
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                }
            ]
        },
        columns() {
            return  [
                {
                    show:false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },{
                    title: '操作',
                    width: 70,
                    render:this.getOperateNodes,
                }, {
                    title: '国家',
                    width: 60,
                    sortable: true,
                    render:(h,{row})=>{
                        return <div>{row.countryCode}</div>
                    }
                },
                {
                    title: '名称',
                    render: (h, { row }) => {
                        let resourcesName = row.resourcesName;
                        if(resourcesName != "" && resourcesName != null){
                            resourcesName = resourcesName.slice(0, 20) + "..."
                        }

                        return <div>{resourcesName || '--'}</div>
                    },
                },
                {
                    title: '网址',
                    render: (h, { row }) => {
                        let resourcesUrl = row.resourcesUrl;
                        if(resourcesUrl != "" && resourcesUrl != null){
                            resourcesUrl = resourcesUrl.slice(0, 20) + "..."
                        }

                        return <div>{resourcesUrl || '--'}</div>
                    },
                },
                {
                    title: 'alexa全球排名',
                    width:110,
                    render: (h, { row }) => {
                        return <div>{row.alexaRank}</div>
                    }
                },
                {
                    title: '网站流量/粉丝数量',
                    width:130,
                    render: (h, { row }) => {
                        return <div>{row.linkFlow}</div>
                    }
                },
                {
                    title: '合作方式',
                    render: (h, { row }) => {
                        return <div>{row.cooperationType}</div>
                    }
                },
                {
                    title: '合作条款',
                    render: (h, { row }) => {
                        let cooperationTerms = row.cooperationTerms;
                        if(cooperationTerms != "" && cooperationTerms != null){
                            cooperationTerms = cooperationTerms.slice(0, 20) + "..."
                        }

                        return <div>{cooperationTerms || '--'}</div>
                    }
                },
                {
                    title: '合作状态',
                    render: (h, { row }) => {
                        const cooperationStatus = row.cooperationStatus
                        var formName = ""
                        if(cooperationStatus == 1){
                            formName = "洽谈中"
                        }
                        if(cooperationStatus == 2){
                            formName = "合作中"
                        }
                        if(cooperationStatus == 3){
                            formName = "已排除"
                        }
                        if(cooperationStatus == 4){
                            formName = "黑名单"
                        }
                        return <div>{formName || '--'}</div>
                    }
                },
                {
                    title: '联系人',
                    render: (h, { row }) => {
                        return <div>{row.contact || '--'}</div>
                    }
                },
                {
                    title: '创建人/编辑人',
                    render: (h, { row }) => {
                        return <div>
                        <div><span>{row.createdName || '--'}</span></div>
                        <div><span>{row.updatedName || '--'}</span></div>
                        </div>
                    },
                },
                {
                    title: '创建时间/更新时间',
                    width:130,
                    render: (h, { row }) => {
                        return <div>
                        <div><span>{row.createdAt || '--'}</span></div>
                        <div><span>{row.updatedAt || '--'}</span></div>
                        </div>
                    },
                },
            ];
        },

    },

};
